import React from 'react'
import firebase from 'firebase/app'
import { capitalize } from 'lodash'
import styled from 'styled-components'
import { Header, Icon, Label, Popup, Button, Rating, Image } from 'semantic-ui-react'

const LoadingContainer = styled.div`
  text-align: center;
  padding: 16px;
`

const CardNumber = styled.p`
  font-weight: bold;
`

const CreditCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

class DriverProfile extends React.PureComponent {
  state = {
    loading: true,
    card: null,
    creditCardkey: null,
  }

  componentDidMount() {
    this.getCreditCard()
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe()
  }

  onRemoveCard = async () => {
    const { driverUid, auth } = this.props
    const { creditCardkey } = this.state

    // eslint-disable-next-line no-alert
    const confirm = window.confirm("Are you sure you want to remove Muuver's credit card")

    if (confirm) {
      await firebase
        .firestore()
        .collection('payment_accounts')
        .doc('deliverers')
        .collection(driverUid)
        .doc(creditCardkey)
        .update({ active: false, handler: auth.username })
    }
  }

  getCreditCard = () => {
    const { driverUid } = this.props

    const collection = firebase
      .firestore()
      .collection('payment_accounts')
      .doc('deliverers')
      .collection(driverUid)
      .where('active', '==', true)

    this.unsubscribe = collection.onSnapshot(snapshots => {
      if (!snapshots.empty) {
        const snapshot = snapshots.docs[0]
        const creditCardkey = snapshot.id
        const data = snapshot.data()

        this.setState({ creditCardkey, card: data.card_number, loading: false })
      } else {
        this.setState({ creditCardkey: null, card: null, loading: false })
      }
    })
  }

  driverFullName =  driver => `${driver.family_name} ${driver.first_name}`

  humanizeDriverStatus = status => status === 'waiting_for_confirm' ? 'Pending' : capitalize(status)

  humanizeDriverOnlineStatus = online => online ? 'Online' : 'Offline'

  statusColor = status => {
    switch (status) {
      case 'available': return 'green'
      case 'busy': return 'red'
      case 'waiting_for_confirm': return 'orange'
      default: return 'default'
    }
  }

  onlineStatusColor = online => online ? 'green' : 'red'

  renderLoading = () => (
    <LoadingContainer>
      <Icon loading name="spinner" size="big" />
    </LoadingContainer>
  )

  renderCreditCard = () => {
    const { loading, card } = this.state

    if (loading || !card) return null

    return (
      <Popup
        hideOnScroll
        wide
        hoverable
        trigger={
          <Icon
            name="credit card"
            style={{ display: "inline-block", fontSize: 25, marginLeft: 10 }}
          />
        }
        position="top center"
      >
        <CreditCard>
          <CardNumber>{card}</CardNumber>
          <Button
            onClick={this.onRemoveCard}
            size="mini"
            color="red"
          >
            Remove
          </Button>
        </CreditCard>
      </Popup>
    )
  }

  renderAbaAcount = () => {
    const { driver } = this.props

    if (!driver.aba) return null

    return (
      <Popup
        hideOnScroll
        wide
        hoverable
        trigger={
          <Image
            src={require('../../../assets/images/aba.png')}
            style={{ width: 25, display: 'inline-block', marginLeft: 10, marginTop: -6 }}
          />
        }
        position="top center"
      >
        <CreditCard>
          <CardNumber>{driver.aba.name}</CardNumber>
          <CardNumber>{driver.aba.number}</CardNumber>
        </CreditCard>
      </Popup>
    )
  }

  render() {
    const { driver } = this.props

    if (!driver) return this.renderLoading()

    return (
      <Header as='h2' icon textAlign='center'>
        <Icon name='user' circular />
        <Header.Content>
          {this.driverFullName(driver)}
          {this.renderCreditCard()}
          {this.renderAbaAcount()}
        </Header.Content>

        <Header.Subheader>{driver.tel}</Header.Subheader>
        <div style={{ textAlign: 'center', fontSize: 16 }}>
          <Rating
            icon="star"
            style={{ fontSize: 5, marginRight: 5 }}
            defaultRating={parseInt(driver.rating_count / driver.reviewers, 10)}
            maxRating={5}
            disabled
          />
          ({driver.reviewers || 0} Ratings)
        </div>
        <div>
          <Label color={this.statusColor(driver.status)}>
            {this.humanizeDriverStatus(driver.status)}
          </Label>
          <Label color={this.onlineStatusColor(driver.online)}>
            {this.humanizeDriverOnlineStatus(driver.online)}
          </Label>
        </div>
      </Header>
    )
  }
}

export default DriverProfile



// WEBPACK FOOTER //
// ./src/containers/drivers/detail/DriverProfile.js